import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import HttpRequest from "./utils/axios.config";
import Notice from "./utils/notice.base";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import store from "./store";
import "../theme/index.css";

Vue.use(ElementUI);
//阻止启动生产消息，常用作指令
Vue.config.productionTip = false;
//每一个vue组件都是Vue的实例，所以组件内this可以拿到Vue.prototype上添加的属性和方法
// //在原型上定义，使其在每个Vue中的实例中可用
Vue.prototype.$http = new HttpRequest();
Vue.prototype.$baseNotice = new Notice();

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  const isPublic = to.matched.some(route => route.meta.requireAuth === false);
  if (!isPublic && to.path !== "/login" && !localStorage.getItem("token")) {
    next({ path: "/login", query: { redirect: to.fullPath } });
    return;
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
